'use client'

import { useTheme } from 'next-themes'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-sh1 items-start text-p-400',
          description: 'group-[.toast]:text-muted-foreground mt-1',
          actionButton: 'group-[.toast]:!bg-primary group-[.toast]:!text-primary-foreground',
          cancelButton: 'group-[.toast]:!bg-muted group-[.toast]:!text-muted-foreground',
          warning: '[&>[data-icon]]:text-status-warning',
          error: '[&>[data-icon]]:text-destructive',
          info: '[&>[data-icon]]:text-brand-text',
          icon: 'mt-1',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
